import ApiService from '../../../../../../services/ApiService'
import moment from 'moment'

export default {
  props: {
    filterProp: Object,
  },

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      alienatedEquipment: undefined,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      calibrationSchedule: [],
      calibrationExecuted: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      alienatedEquipmentHeader: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'identification',
        },
        {
          text: 'Nome padrão do equipamento',
          align: 'center',
          value: 'standardEquipmentName',
        },
        {
          text: 'Data de Alienação',
          align: 'center',
          value: 'dateFormated',
        },
        {
          text: 'Motivo',
          align: 'center',
          value: 'alienatedMotive',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
        },
        {
          text: 'Patrimônio',
          align: 'center',
          value: 'propertyCode',
        },
      ],
      total: 0,
    }
  },

  async created() {
    this.listalienatedEquipment()
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `alienated_Equipment_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/alienatedEquipment', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listalienatedEquipment() {
      await this.apiService
        .post('reports/alienatedEquipment', this.filterProp)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.alienatedEquipment = []

          this.showChart = response.content.objects.length > 0
          response.content.objects.map((value) => {
            let dateFormated = moment(value.alientedDate).format('DD/MM/YYYY')
            this.alienatedEquipment.push({ ...value, dateFormated })
          })
        })
        .catch((err) => {})

      this.fillalienatedEquipmentChartData()
    },

    fillalienatedEquipmentChartData() {
      this.alienatedEquipmentChartData = {
        labels: [''],
        datasets: [
          {
            label: 'Calibrações Agendadas',
            data: this.calibrationSchedule,
            backgroundColor: '#87AFA6',
          },
          {
            label: 'Calibrações Executadas',
            data: this.calibrationExecuted,
            backgroundColor: '#BAB3D3',
          },
        ],
      }
    },
  },

  watch: {
    page() {
      this.filterProp.page = this.page
      this.listalienatedEquipment()
    },
  },

  computed: {
    totalInPeriod() {
      if (this.alienatedEquipment) return this.total
    },
  },
}
